import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { Box } from "@material-ui/core";
import { CreatorModeContext } from "src/context/CreatorMode";
import CreatorModeToggle from "src/component/CreatorModeToggle";
// import SettingsContext from "src/context/";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#F8FAFB",
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    transition: "background-color 0.3s ease",
  },
  rootCreatorMode: {
    display: "flex",
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: "#121212",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    overflowX: "hidden",
    overflowY: "auto",
    transition: "background-color 0.3s ease",
  },

  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: 96,
    minHeight: "calc(100vh - 75px)",
    transition: "padding 0.3s ease",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 300,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },
  wrapperCreatorMode: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#121212",
    paddingTop: 0,
    paddingLeft: 0,
    minHeight: "100vh",
    width: "100%",
    transition: "padding 0.3s ease, background-color 0.3s ease",
  },

  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "auto",
    background: "#FAFAFA",
    transition: "background-color 0.3s ease",
  },
  contentContainerCreatorMode: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "auto",
    background: "#121212",
    width: "100%",
    height: "100%",
    transition: "background-color 0.3s ease",
  },

  dashboardWrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "auto",
    position: "relative",
    backgroundColor: "#F8FAFB",
    paddingTop: 100,
    minHeight: "calc(100vh - 75px)",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 300,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },

  dashboardContent: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
    overflowX: "auto",
    position: "relative",
    transition: "padding 0.3s ease",
    // padding: "28px 25px 25px ",
    [theme.breakpoints.down("md")]: {
      padding: "25px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 10px 10px ",
    },
  },
  dashboardContentCreatorMode: {
    flex: "1 1 auto",
    height: "100vh",
    width: "100%",
    overflow: "auto",
    position: "relative",
    padding: 0,
    backgroundColor: "#121212",
    transition: "padding 0.3s ease, background-color 0.3s ease",
  },

  content: {
    flex: "1 1 auto",
    minHeight: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    position: "relative",
    padding: "28px 25px 25px ",
    transition: "padding 0.3s ease",
    [theme.breakpoints.down("md")]: {
      padding: "30px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "45px 10px 10px ",
    },
  },
  contentCreatorMode: {
    flex: "1 1 auto",
    height: "100vh",
    width: "100%",
    overflow: "auto",
    position: "relative",
    padding: 0,
    backgroundColor: "#121212",
    transition: "padding 0.3s ease, background-color 0.3s ease",
  },
  floatingToggle: {
    position: "fixed",
    top: 20,
    right: 20,
    zIndex: 10000,
    backgroundColor: "rgba(30, 30, 30, 0.9)",
    padding: "8px 16px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(30, 30, 30, 1)",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { isCreatorMode } = useContext(CreatorModeContext);

  // const themeSeeting = useContext(SettingsContext);

  const dashboardRoute = window.location.pathname === "/dashboard";

  return (
    <div className={isCreatorMode ? classes.rootCreatorMode : classes.root}>
      {!isCreatorMode && (
        <>
          <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
          <NavBar
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
          />
        </>
      )}
      {isCreatorMode && <CreatorModeToggle />}
      <div
        className={
          isCreatorMode ? classes.wrapperCreatorMode : classes.wrapper
        }
      >
        <div
          className={
            isCreatorMode
              ? classes.contentContainerCreatorMode
              : classes.contentContainer
          }
        >
          <div
            className={
              isCreatorMode
                ? dashboardRoute
                  ? classes.dashboardContentCreatorMode
                  : classes.contentCreatorMode
                : dashboardRoute
                ? classes.dashboardContent
                : classes.content
            }
            id="main-scroll"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
